import * as React from 'react';

export interface ReviewSupportGroupsContextType {
  onApprove: (id: number) => void;
  onReject: (id: number, comment: string) => void;
}

export const ReviewSupportGroupsContext =
  React.createContext<ReviewSupportGroupsContextType | null>(null);
